export const setObjectByString = (obj: Object, path: string, value: any) => {

    var a = path.split('.');
    var context: any = obj;
    var myregexp = /([a-zA-Z]+)(\[(\d)\])+/; // matches:  item[0]
    var match = null;

    for (var i = 0; i < a.length - 1; i += 1) {

        match = myregexp.exec(a[i]);

        if (match !== null) {
            if (!context[match[1]]) context[match[1]] = [{}];
            if (!context[match[1]][match[3]]) context[match[1]][match[3]] = {};
            context = context[match[1]][match[3]];
        }
        else {
            if (!context[a[i]]) context[a[i]] = {};
            context = context[a[i]];
        }

    }

    // check for ending item[xx] syntax
    // @ts-ignore
    match = myregexp.exec([a[a.length - 1]]);

    if (match !== null) {
        if (!context[match[1]]) context[match[1]] = [];
        context[match[1]][match[3]] = value;
    }
    else {
        context[a[a.length - 1]] = value;
    }

}

export const getObjectByString = (o: { [index: string]: any }, s: string) => {
    if (typeof o !== 'object') return null;
    s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    s = s.replace(/^\./, '');           // strip a leading dot
    var a = s.split('.');
    for (var i = 0, n = a.length; i < n; ++i) {
        var k = a[i];
        if (typeof o === 'object' && k in o) {
            o = o[k];
        } else {
            return;
        }
    }
    return o;
}

/*!
 * Find the differences between two objects and push to a new object
 * (c) 2019 Chris Ferdinandi & Jascha Brinkmann, MIT License, https://gomakethings.com & https://twitter.com/jaschaio
 * @param  {Object} obj1 The original object
 * @param  {Object} obj2 The object to compare against it
 * @return {Object}      An object of differences between the two
 */
export const getObjectsDiff = (obj1: { [index: string]: any }, obj2: { [index: string]: any }, ignoreId: boolean = true, ignoreNull: boolean = true, keep: string[] = []) => {

    // Make sure an object to compare is provided
    if (!obj2 || Object.prototype.toString.call(obj2) !== '[object Object]') {
        return obj1;
    }

    //
    // Variables
    //

    var diffs: { [index: string]: any } = {};
    var key;


    //
    // Methods
    //

    /**
     * Check if two arrays are equal
     * @param  {Array}   arr1 The first array
     * @param  {Array}   arr2 The second array
     * @return {Boolean}      If true, both arrays are equal
     */
    var arraysMatch = function (arr1: any[], arr2: any[]) {

        // Check if the arrays are the same length
        if (arr1.length !== arr2.length) return false;

        // Check if all items exist and are in the same order
        for (var i = 0; i < arr1.length; i++) {
            if (arr1[i] !== arr2[i]) return false;
        }

        // Otherwise, return true
        return true;

    };

    /**
     * Compare two items and push non-matches to object
     * @param  {*}      item1 The first item
     * @param  {*}      item2 The second item
     * @param  {String} key   The key in our object
     */
    var compare = function (item1: any, item2: any, key: any) {

        // Get the object type
        var type1 = Object.prototype.toString.call(item1);
        var type2 = Object.prototype.toString.call(item2);

        // If type2 is undefined it has been removed
        if (type2 === '[object Undefined]') {
            diffs[key] = null;
            return;
        }

        // If items are different types
        if (type1 !== type2) {
            diffs[key] = item2;
            return;
        }

        // If an object, compare recursively
        if (type1 === '[object Object]') {
            var objDiff = getObjectsDiff(item1, item2, true);
            if (Object.keys(objDiff).length > 0) {
                diffs[key] = objDiff;
            }
            return;
        }

        // If an array, compare
        if (type1 === '[object Array]') {
            if (!arraysMatch(item1, item2)) {
                // Lets Find The Differences In The Array
                let arrayDifs: any[] = [];
                item2.forEach((element: any, index: number) => {
                    var arrayObjDiff = getObjectsDiff(item1[index], element, true);
                    if (Object.keys(arrayObjDiff).length > 0) {
                        if (ignoreId) {
                            arrayDifs.push(arrayObjDiff);
                        } else {
                            if (element.id) {
                                arrayDifs.push({
                                    id: element.id,
                                    ...arrayObjDiff
                                });
                            } else  {
                                arrayDifs.push({
                                    id: null,
                                    ...arrayObjDiff
                                });
                            }
                        }
                    }
                });
                diffs[key] = arrayDifs;
            }
            return;
        }

        // Else if it's a function, convert to a string and compare
        // Otherwise, just compare
        if (type1 === '[object Function]') {
            if (item1.toString() !== item2.toString()) {
                diffs[key] = item2;
            }
        } else {
            if (item1 !== item2 ) {
                diffs[key] = item2;
            }
        }

    };


    //
    // Compare our objects
    //

    // Loop through the first object
    for (key in obj1) {
        if (obj1.hasOwnProperty(key)) {
            compare(obj1[key], obj2[key], key);
        }
    }

    // Loop through the second object and find missing items
    for (key in obj2) {
        if (obj2.hasOwnProperty(key)) {            
            if (!obj1 || ( !obj1[key] && obj1[key] !== obj2[key] ) ) {
                diffs[key] = obj2[key];
            }
        }
    }

    if (!ignoreId && obj1 && obj1.hasOwnProperty('id')) {
        diffs['id'] = obj1.id;
    }

    if (ignoreNull) {
        for (key in diffs) {
            if (diffs[key] === null) {
                delete diffs[key];
            }
        }
    }

    keep.forEach((key: string)=>{
        if (obj1.hasOwnProperty(key)&&!diffs.hasOwnProperty(key)) {
            let propType = Object.prototype.toString.call(obj1[key]);
            if (propType === '[object Array]') {
                diffs[key] = [];
            }
        }
    });

    // Return the object of differences
    return diffs;

};